import { Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Trend } from './dateRangeUtils'

type Props = {
  value: Trend
}

const formatPercent = (value: number): string => {
  if (value > 0) {
    return `+${value.toFixed(1)}%`
  }

  if (value < 0) {
    return `-${Math.abs(value).toFixed(1)}%`
  }

  return '0.0%'
}

export const TrendCell: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation()

  // "From zero" has no meaningful ratio, so show the fresh gain instead of a fake +100%.
  if (value.type === 'new') {
    return (
      <Typography component="span" sx={{ color: 'success.main', fontWeight: 600 }}>
        {t('payment.trendNew', { increase: value.increase })}
      </Typography>
    )
  }

  const formatted = formatPercent(value.value)
  const color = value.value > 0 ? 'success.main' : value.value < 0 ? 'error.main' : 'text.secondary'

  return (
    <Typography
      component="span"
      sx={{
        color,
        fontWeight: value.value === 0 ? 400 : 600
      }}
    >
      {formatted}
    </Typography>
  )
}
